export default __webpack_public_path__ + "stroke-width-4.asset.4446b73134c4aead14e3c9df31c516b2.svg";